import { render, staticRenderFns } from "./ButtonPane.vue?vue&type=template&id=115344d8"
import script from "./ButtonPane.vue?vue&type=script&lang=js"
export * from "./ButtonPane.vue?vue&type=script&lang=js"
import style0 from "./ButtonPane.vue?vue&type=style&index=0&id=115344d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports